<template>
  <div id="tab_wrapper">

    <div class="flex justify-around mb-10">
      <div class="text-center">
        <a :class="{ 'text-pink border-pink': tab === 'all', 'text-gray-200 border-transparent': tab != 'all' }" @click.prevent="showAllActivities" href="#" class="uppercase hover:text-pink hover:border-pink border-b-4 font-medium text-sm">All</a>
      </div>
      <div class="text-center">
        <a :class="{ 'text-pink border-pink': tab === 'donors', 'text-gray-200 border-transparent': tab != 'donors' }" @click.prevent="showDonors" href="#" class="uppercase hover:text-pink hover:border-pink border-b-4 font-medium text-sm">Donors</a>
      </div>
      <div class="text-center">
        <a :class="{ 'text-pink border-pink': tab === 'supporters', 'text-gray-200 border-transparent': tab != 'supporters' }" @click.prevent="showSupporters" href="#" class="uppercase hover:text-pink hover:border-pink border-b-4 font-medium text-sm">Supporters</a>
      </div>
    </div>

    <div class="tab-content">

      <transition name="fade" mode="out-in">
        <div v-show="tab === 'all'" class="tab-pane" key="all">

          <div v-if="isLoading" class="flex justify-center items-center space-x-2 mt-8 border border-gray-200 py-4 px-5 w-full text-lg rounded-full">
            <div class="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full" role="status"></div>
            <div class="text-lg text-gray-500">Loading activities, please wait...</div>
          </div>

          <div v-if="recentActivities.length > 0" >
            <div class="flex flex-col space-y-4 mt-6 mb-6">
              
              <div
                v-for="activity in recentActivities"
                :class="{
                    'bg-pink-50': activity.action !== 'campaign_created' && activity.action !== 'honoree_donation_created',
                    'bg-blue-50': activity.action === 'campaign_created',
                    'bg-purple-100': activity.action === 'honoree_donation_created',
                    'md:items-center': activity.action !== 'honoree_donation_created',
                    'md:items-start': activity.action === 'honoree_donation_created'
                }"
                class="w-full text-lg flex flex-col md:flex-row activity-class rounded-3xl pr-6 pl-20 md:pr-8 md:pl-16 py-4 relative"
              >

              <div class="absolute -left-5 md:-left-8 -top-1 md:-top-[5px]" :class="{ 'md:-top-0.5': activity.action === 'honoree_donation_created' }">
                  <div v-show="activity.action == `campaign_created`"  class="bg-blue text-white rounded-full h-20 w-20 mr-6 flex items-center justify-center text-2xl border-solid border-4 border-white">
                    <img class="block w-3/5" src="/img/campaign-icon.png">
                  </div>
                  <div v-show="activity.action == `honoree_donation_created`"  class="bg-purple text-white rounded-full h-20 w-20 mr-6 flex items-center justify-center text-2xl border-solid border-4 border-white">
                    <img class="block w-3/5" src="/img/honor-icon.png">
                  </div>
                  <div v-show="activity.action == `donation_created`"  class="bg-pink text-white rounded-full h-20 w-20 mr-6 flex items-center justify-center text-2xl border-solid border-4 border-white">
                    <img class="block w-3/5" src="/img/donation-icon.png">
                  </div>
                  <div v-show="activity.action == `pledge_created`"  class="bg-pink text-white rounded-full h-20 w-20 mr-6 flex items-center justify-center text-2xl border-solid border-4 border-white">
                    <svg class="block w-3/5" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        viewBox="0 0 100 125" style="enable-background:new 0 0 100 125;" xml:space="preserve">

                      <path class="st0" d="M53.9,107.9c16,0,27.7-15.2,26.6-29.8c-0.6-13.9,0.4-25.6,2.6-39.1c0.3-2.2,1.1-4.4,0.7-6.5
                                                c-0.3-1.4-1.9-3-3.3-3.3c-1.1-0.3-2.9,1.1-3.8,2.2c-0.8,1.1-0.8,2.8-1.1,4.3c-1,5.2-1.9,10.6-2.9,15.8c-0.6,2.9-5,2.5-4.9-0.6
                                                c0,0,0,0,0-0.1c0.7-10.2,1.3-20.3,1.8-30.4c0.1-2.9-0.3-5.5-3.8-5.5c-3.5,0-3.9,2.5-4.2,5.4c-0.7,9.8-1.5,19.4-2.2,29.2
                                                c-0.1,1.2-1.3,2.3-2.5,2.2c-1.7-0.1-1.5-1-1.5-3c0.1-5,0-10.1,0-15c0-6.6,0.1-13.4-0.1-20c0-0.8-0.3-1.4-1-2.2c-1-1-4-1.2-5.1-0.6
                                                c-0.7,0.4-1,0.8-1.4,2.2c-0.4,1.1-0.3,2.5-0.3,3.7c0,7.2,0,14.3,0,21.6c0,3.7,0,7.6,0,11.4c0,1.2-0.4,2.1-1.5,2.2l-0.6,0.1
                                                c-1.3,0.1-2.5-0.7-2.8-1.9c-1.4-9.5-2.8-19-4.2-28.5c-0.4-2.5-2.5-4-4.3-3.6c-3.2,0.3-3.2,2.5-3.6,4.3c-0.4,1.7,0.3,3.7,0.6,5.6
                                                c1.5,12.3,3.1,24.4,4.6,36.6c0.3,2.8,0.6,5.2-2.5,5.2c-1.8,0-4.2-1.7-5.3-3.3c-2.4-3.6-4-7.7-6-11.6c-1.3-2.5-4.7-5.1-7.1-3.2
                                                c-2.1,1.8-2.2,4.3-1.1,6.8C18,68.9,22,79.4,26.5,89.6c1.5,3.4,3.8,6.6,6.3,9.4c3.2,3.6,10.1,9,20.5,9 M66.7,79.9
                                                c-1,1.9-2.4,3.4-3.8,5.1c-2.5,2.6-5.3,5-8.2,7.2c0,0,0,0-0.1,0.1c-0.6-0.4-1.3-1-1.9-1.4c-2.6-2.1-5.3-4.4-7.5-6.9
                                                c-1.3-1.4-2.2-2.8-3.1-4.4c-0.8-1.9-0.8-3.7-0.1-5.6c0.6-1.5,1.4-2.8,2.6-3.6c1.8-1.2,3.9-1.5,6-0.7c1.1,0.4,1.9,1.2,2.6,2.2
                                                c0.4,0.7,0.8,2.9,1.3,3.6c0,0.1,0,0.1,0.1,0.1c0.4-0.8,1.3-3,1.8-3.9c0.7-1.1,1.4-1.8,2.6-2.3c1-0.4,1.8-0.4,2.8-0.3
                                                c2.6,0.4,4.2,1.9,5.1,4.3c0.4,1.1,0.7,2.2,0.7,3.3C67.7,77.7,67.2,78.8,66.7,79.9z"/>
                      <path d="M62.6,105.4"/>
                                        </svg>
                  </div>
                  <div v-show="activity.action == `pledge_activity_created`"  class="bg-green text-white rounded-full h-20 w-20 mr-6 flex items-center justify-center text-2xl border-solid border-4 border-white">
                    <i class="fas fa-trophy block w-3/5"></i>
                  </div>

                </div>

                <div class="flex-grow md:pr-8">
                  <!-- Campaign Created Activity -->
                  <p v-if="activity.action == 'campaign_created'" class="text-base leading-tight">
                    <p>
                      <strong>{{ activity.subject }}</strong> created a campaign in support of the
                    </p>
                    <p v-if="activity.sub_campaign_id != campaignId">
                      <a class="text-blue hover:text-blue-600" :href="campaignUrl(activity.sub_campaign_id)">
                        <strong>{{ activity.campaignName }} campaign</strong>
                      </a>
                    </p>
                    <p v-else>
                      <strong class="text-blue">{{ activity.campaignName }} campaign</strong>
                    </p>
                  </p>
                  
                  <!-- Donation Created Activity with Different Campaign ID -->
                  <div v-else-if="activity.action == 'donation_created' && activity.sub_campaign_id != activity.campaign_id" class="flex flex-col text-base text-black leading-tight">
                    <p>
                      <strong>{{ activity.subject || 'An anonymous donor' }}</strong> donated to 
                      
                      <span class="md:block" v-if="activity.sub_campaign_id != campaignId">
                        <a class="text-pink hover:text-pink-600" :href="campaignUrl(activity.sub_campaign_id)">
                          <strong>{{ activity.campaignName }} campaign</strong>
                        </a>
                      </span>

                      <span class="md:block" v-if="activity.sub_campaign_id == campaignId">
                        <strong class="text-pink hover:text-pink-600">{{ activity.campaignName }} campaign</strong>
                      </span>
                    </p>
                  </div>

                  <!-- Donation Created Activity with Same Campaign ID -->
                  <div v-else-if="activity.action == 'donation_created' && activity.sub_campaign_id == activity.campaign_id" class="flex flex-col text-base text-black leading-tight">
                    <p>
                      <strong>{{ activity.subject || 'An anonymous donor' }}</strong> donated to 
                      
                      <span class="md:block" v-if="activity.sub_campaign_id == campaignId">
                        <strong class="text-pink hover:text-pink-600">{{ activity.campaignName }} campaign</strong>
                      </span>
                    </p>
                  </div>

                  <!-- Honoree Donation Created Activity -->
                  <div v-else-if="activity.action == 'honoree_donation_created'" class="flex flex-col text-base text-black leading-tight">
                    <p>
                      <strong>{{ activity.subject || 'An anonymous donor' }}</strong> donated 
                      <span v-if="activity.dedication === 'in_honor_of'">in honor of</span>
                      <span v-else-if="activity.dedication === 'in_memory_of'">in memory of</span>
                      
                      <span class="md:block mb-3">
                        <strong class="text-purple hover:text-purple-600 md:block">{{ activity.sub_message }}</strong>
                      </span>
                    </p>
                  </div>

                  <!-- Other Activities (Excluding Campaign Created) -->
                  <p v-else class="text-base text-gray-500 leading-tight">
                    <strong>{{ activity.subject }}</strong> {{ activity.message }}
                  </p>
                  
                  <p v-if="activity.action != 'campaign_created'" class="text-base text-gray-500 leading-tight italic mt-3 md:mt-0">
                    {{ getMessageToRecipient(activity) }}
                  </p>
                </div>

                <div v-if="activity.action == 'donation_created'" class="flex flex-col items-start text-base leading-tight w-20 mt-3 md:mt-0">
                  <span>Amount</span>
                  <span class="text-pink font-bold">{{ getDonationAmount(activity.message) }}</span>
                </div>

                <div v-if="activity.action == 'honoree_donation_created'" class="flex flex-col items-start text-base leading-tight w-20 mt-3 md:mt-0">
                  <span>Amount</span>
                  <span class="text-purple font-bold">{{ activity.donationAmount }}</span>
                </div>

                <div v-if="activity.action == 'campaign_created' && activity.sub_campaign_id != this.campaignId" class="flex flex-col items-start text-base leading-tight w-20 mt-3 md:mt-0">
                  <span>Goal</span>
                  <span class="text-blue font-bold">{{ formatCurrency(activity.campaignGoal) }}</span>
                </div>

              </div>
            </div>

            <!-- Load More Button -->
            <a v-if="next_page_url" href="#!" @click="loadMore($event)" id="loadMore"
              :disabled="isLoadMoreDisabled"
              class="mb-3 bg-white border-2 border-blue hover:border-blue-700 hover:text-blue-700 text-blue block py-3 font-medium uppercase text-center text-lg mt-10 focus:outline-none focus:ring-blue-200 rounded-full transform transition-all duration-500 w-3/4 lg:w-1/2 mx-auto">
              <div class="flex items-center justify-center relative">
                <span class="text-center mx-auto">Load More</span>
                <div class="spinner-container">
                  <div v-if="isLoadingMore" class="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full" role="status"></div>
                </div>
              </div>
            </a>
          </div>

          <div v-else-if="!isLoading" class="mb-6">
            <div class="flex flex-col mt-6 space-y-5">
              <div class="border border-gray-200 py-4 px-5 w-full text-lg flex items-center">
                <p>Be the first to <a href="#" class="text-blue hover:text-blue-600">donate</a> or <a :href="this.fundraiseUrl()" class="text-blue hover:text-blue-600">create your own personal fundraising page</a> and support our campaign!</p>
              </div>
            </div>
          </div>

        </div>
      </transition>


      <transition name="fade" mode="out-in">
        <donor-activities v-show="tab === 'donors'" :campaign-id="campaignId" class="tab-pane" key="donors"/>
      </transition>

      <transition name="fade" mode="out-in">
        <campaign-only-activities v-show="tab === 'supporters'" :campaign-id="campaignId" class="tab-pane" key="supporters"/>
      </transition>

    </div>

  </div>
</template>

<script>
import DonorActivities from "./DonorActivities"
import CampaignOnlyActivities from "./CampaignOnlyActivities"
import _ from 'lodash'

export default {
  name: 'CampaignActivities',
  components: {
    DonorActivities,
    CampaignOnlyActivities,
  },
  props: {
    campaignId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      tab: 'all',
      isLoading: true,
      isLoadingMore: false,
      recentActivities: [],
      next_page_url: '/api/open/campaigns/activity/' + this.campaignId,
      isLoadMoreDisabled: false
    }
  },

  created() {
    this.isLoading = true
    this.isLoadingMore = false
    this.loadActivities()

    this.emitter.on('campaign-donation-update', (campaign) => {
      this.campaign = campaign
      this.next_page_url = '/api/open/campaigns/activity/' + this.campaignId
      this.recentActivities = []
      this.loadActivities()
    })
  },

  methods: {
    formatCurrency(amount) {
      if (!amount && amount !== 0) return ''; // Ensure that you handle null, undefined, or empty string correctly

      // Ensure two decimal points
      let number = parseFloat(amount);
      if (isNaN(number)) {
        return amount; // If the input is not a number, return it as it is.
      }

      return `$${number.toFixed(2)}`; // Convert to string with two decimals prefixed with dollars
    },
    getDonationAmount(message) {
      const amountRegex = /\$\d+(?:\.\d{0,2})?/; // This regex matches dollar amounts like $1000 or $1000.00
      const matches = message.match(amountRegex);
      
      if (matches && matches.length > 0) {
        let donationAmount = matches[0]; // Get the first match which should be the dollar amount
        // Ensure there are two decimal points
        if (!donationAmount.includes('.')) {
          donationAmount += '.00';
        }
        return donationAmount;
      } else {
        return null; // If no dollar amount format was found, return null or a default
      }
    },

    getMessageToRecipient(activity) {
      return _.get(activity.meta_data, 'message_to_recipient', null)
    },

    loadMore(event) {
      event.preventDefault(); // This will prevent the default action of the anchor link
      this.isLoadMoreDisabled = true;
      this.isLoadingMore = true;
      this.loadActivities().then(() => {
        this.isLoadMoreDisabled = false;
        this.isLoadingMore = false;
      });
    },

    showAllActivities() {
      this.tab = 'all';
      this.emitter.emit('show-donor-activities-off');
      this.emitter.emit('show-supporters-activities-off');
    },

    showDonors() {
      this.tab = 'donors';
    },

    showSupporters() {
      this.tab = 'supporters';
    },

    async loadActivities() {
      if (this.next_page_url) {
        try {
          const response = await axios.get(this.next_page_url);

          if (!response.data || !Array.isArray(response.data.data)) {
            console.error('Unexpected response format:', response.data);
            throw new Error('Unexpected response format');
          }

          const activitiesWithDetails = response.data.data.map(activity => {
            if (!activity) {
              console.error('Undefined activity in response');
              return null;
            }
            if (activity.action === 'honoree_donation_created' && activity.donation_id) {
              return this.fetchDonationDetails(activity);
            }
            return activity;
          });

          const resolvedActivities = await Promise.all(activitiesWithDetails);

          // Filter out null activities and the activity for the creation of the current campaign
          const filteredActivities = resolvedActivities.filter(activity => 
            activity && !(activity.action === 'campaign_created' && activity.sub_campaign_id === this.campaignId)
          );

          this.recentActivities.push(...filteredActivities);
          this.next_page_url = response.data.next_page_url;
        } catch (error) {
          console.error('Error loading activities:', error);
          // Handle error appropriately, maybe set an error state
          this.isLoading = false;
          this.isLoadingMore = false;
          return; // Exit the method early
        }
      }

      this.isLoading = false;
      this.isLoadingMore = false;
    },

    campaignUrl(id) {
      return `/campaigns/${id}`
    },

    fundraiseUrl() {
      return '/create-my-campaign/'+this.campaignId
    },

    async fetchDonationDetails(activity) {
      try {
        const response = await axios.get(`/api/open/donations/${activity.donation_id}`);
        const donation = response.data;

        // Directly assign donation details to this activity
        activity.donationAmount = this.formatCurrency(donation.amount);
        activity.isAnonymous = donation.is_anonymous;
        activity.dedication = donation.dedication;
        activity.inMemoryHonorOf = donation.in_memory_honor_of;
        activity.honoreeName = donation.honoree_name;
        return activity;
      } catch (error) {
        console.error('Error fetching donation details:', error);
        return activity;
      }
    },
  },
}
</script>
<style scoped>
.st0{
  fill:#FFFFFF;
}
.spinner-border {
  border-color: transparent;
  border-top-color: #3490dc; /* Spinner color */
  border-right-color: #3490dc; /* Spinner color */
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

.spinner-space {
  width: 2rem; /* Same as spinner width */
  height: 2rem; /* Same as spinner height */
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner-container {
  position: absolute;
  right: 1rem;
  width: 2rem; /* Same as spinner width */
  height: 2rem; /* Same as spinner height */
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner-border {
  border-color: transparent;
  border-top-color: #3490dc; /* Spinner color */
  border-right-color: #3490dc; /* Spinner color */
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.75s;
}

.fade-enter, .fade-leave-to /* adjusted */ {
  position: absolute;
  opacity: 0;
  left: 0;
  top: 0;
  width: 100%;
}

.tab-content {
  transition: opacity 0.75s, transform 0.75s;
  width: 100%;
}

.tab-content.fade {
  opacity: 0;
}
</style>
